import { assign, find } from 'lodash'
import { default as doFilter } from './filters'
import { warning } from '@/utils/alert'
import { dateToMysql } from '@/helpers/dates'
import moment from 'moment'

export default function () {
  // validação e primeiro campo focus
  this.$v.$touch()
  this.$nextTick(() => this.focusFirstStatus())

  // Se existe convenios para o paciente seleionado.
  if (this.agenda.covenant_type) {
    if (this.agenda.patient.active_covenants.length === 0) {
      warning('O Paciente selecionado não tem nenhum convênio cadastrado.')
      return
    }
  }
  // verificando se a data inicial sera meno que a final.
  if (this.agenda.date_end !== null && this.agenda.date_start !== null) {
    const isAfter = moment(dateToMysql(this.agenda.date_end)).isSameOrAfter(dateToMysql(this.agenda.date_start))

    if (!isAfter) {
      warning('A data final precisa ser maior que a data inicial.')
      this.agenda.valid_to_end = ''
      return
    }
  }

  // precisa informar um periodo manha, tarde ou noite
  if (this.agenda.period === null && this.agenda.date_start !== null && this.agenda.date_end) {
    warning('Você precisa informar um período.')
    return
  }

  if (this.force_professional && !this.agenda.professional.id) {
    if (this.$v.agenda.professional.id.$touch()) {
      return
    }
    return warning('Informe um profissional')
  }

  const agenda = assign({}, this.agenda)
  const user = assign({}, this.user)
  const level = find(this.levelOptions, {id: agenda.level_id}) || null
  const covenant = find(this.covenantTypeOptions, {id: agenda.covenant_type}) || null

  const searchedBy = []
  const filters = {}
  doFilter(searchedBy, filters, agenda, covenant, level, user)

  this.setValuesSearchedBy(searchedBy)
  this.setFilters(filters)

  this.loadAgendas()
    .then(() => {
    })

  return this.$router.push({name: 'patient.agendas.search.results'})
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/methodDoLoad.js